import {call, put} from "redux-saga/effects";
import {confirmerPaiementSouscriptionApi} from "../../../../common/apis/souscriptionApi";
import * as actions from "../state/confirmerPaiementSouscriptionActions";

export function* confirmerPaiementSouscriptionSaga({ payload }) {
  try {
    const response = yield call(confirmerPaiementSouscriptionApi, payload);
    console.log(response);

    yield put(
      actions.confirmerPaiementSouscriptionSuccessAction(response.data.body)
    );
  } catch (error) {
    console.log(error);
    yield put(actions.confirmerPaiementSouscriptionFailAction(error));
  }
}
